const UserModel = require("@/appModel/users/UserModel")
const NoticeModel = require("@/appModel/Notice/NoticeModel")
const DateUtil = require('@/appUtils/DateUtil')

class InspectPlaceNoticeViewModel {
  constructor(tenantId, userSub, linkedId, treePlace) {
    this.tenantId = tenantId
    this.userSub = userSub
    this.targetUsers = []
    this.typeList = [{value:0, label: "確認依頼"}, {value:1, label: "指示"}, {value:2, label: "確認"}]
    this.title = ""
    this.contents = ""
    this.linkedId = linkedId
    this.noticeData = null
    this.userDictionary = {}
    this.userList = []
    this.treePlace = treePlace
  }

  static async init(tenantId, userSub, linkedId, treePlace) {
    let viewModel = new InspectPlaceNoticeViewModel(tenantId, userSub, linkedId, treePlace)
    viewModel.userList = await UserModel.getUserList(tenantId)
    viewModel.userList.forEach(function(item) {
      // 削除ユーザは省く
      if (!item.user.deleted) {
        viewModel.userDictionary[item.user.userId] = Object.assign({}, item.user)
      }
    }.bind(this))

    return viewModel
  }
  async save() {
    console.log(`notice save`)
    try {
      let noticeList = []
      // 通知レコードを作成する
      for (let i = 0;i < this.targetUsers.length;i++) {

        let userA = this.userSub
        let userB = this.targetUsers[i]
        // 通知作成者が閲覧するレコード
        console.log(`userA ${userA} userB ${userB}`)
        if (userA != userB) {
          console.log(`2レコード`)
          noticeList.push(await NoticeModel.getNewData(userA, userB))
          noticeList[noticeList.length - 1].notice.targetUsers = Array.from(this.targetUsers)
          noticeList[noticeList.length - 1].notice.title = this.title
          noticeList[noticeList.length - 1].notice.Readed = true
          noticeList[noticeList.length - 1].notice.content = this.contents
          noticeList[noticeList.length - 1].notice.linkedId = this.linkedId
          noticeList[noticeList.length - 1].notice.sourceName = this.treePlace
          noticeList[noticeList.length - 1].notice.type = "2"
        
          // 受信者が閲覧するレコード
          noticeList.push(await NoticeModel.getNewData(userB, userA, userB))
          noticeList[noticeList.length - 1].notice.targetUsers = Array.from(this.targetUsers)
          noticeList[noticeList.length - 1].notice.title = this.title
          noticeList[noticeList.length - 1].notice.Readed = false
          noticeList[noticeList.length - 1].notice.content = this.contents
          noticeList[noticeList.length - 1].notice.linkedId = this.linkedId
          noticeList[noticeList.length - 1].notice.sourceName = this.treePlace
          noticeList[noticeList.length - 1].notice.type = "2"
        } else {
          console.log(`1レコード`)
          noticeList.push(await NoticeModel.getNewData(userA, userB, userB))
          noticeList[noticeList.length - 1].notice.targetUsers = Array.from(this.targetUsers)
          noticeList[noticeList.length - 1].notice.title = this.title
          noticeList[noticeList.length - 1].notice.Readed = true
          noticeList[noticeList.length - 1].notice.content = this.contents
          noticeList[noticeList.length - 1].notice.linkedId = this.linkedId
          noticeList[noticeList.length - 1].notice.sourceName = this.treePlace
          noticeList[noticeList.length - 1].notice.type = "2"
        }
        
      }
      console.log(`notice ${noticeList.length}`)
      // 通知を作成する
      for (let i = 0; i < noticeList.length; i++) {
        await NoticeModel.addNotice(noticeList[i])
      }
      return true
    } catch (e) {
      console.log(JSON.stringify(e))
      return false

    }
  }
  
}

module.exports = InspectPlaceNoticeViewModel;